module.exports = __webpack_public_path__ + "img/7.6d8af35d.jpg";